// extracted by mini-css-extract-plugin
export default {"container":"banner-tours_container__xnfSX","list":"banner-tours_list__S5Pnw","button":"banner-tours_button__g4xJJ"};